import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./MisionVision.css";
import { FaBullseye, FaEye, FaHandsHelping } from "react-icons/fa";
import visionImg from "../assets/nosotros/mision_vision/mision.jpg";
import misionImg from "../assets/nosotros/mision_vision/vision.jpg";
import valoresImg from "../assets/nosotros/mision_vision/valores.jpg"; // 🔹 Puedes cambiar la imagen

const MisionVision = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="mision-vision-page">
     
      <div className="mv-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Misión, Visión y Valores</h1>
          <p className="lead">
            Comprometidos con la excelencia tecnológica, los valores y el desarrollo humano.
          </p>
        </div>
      </div>

    
      <div className="container py-5">
        {/*  VISIÓN */}
        <div className="row align-items-center mb-5" data-aos="fade-right">
          <div className="col-md-6 text-center">
            <img src={visionImg} alt="Visión" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaEye className="mv-icon" />
              <h2 className="section-title">Nuestra Visión</h2>
              <p>
                “Ser al 2026 una Institución de Educación Superior Tecnológica licenciada,
                acreditada y reconocida a nivel local y nacional; líder en la formación
                de profesionales técnicos, promoviendo la investigación e innovación
                tecnológica con responsabilidad social. Competente, con visión empresarial,
                que contribuya al desarrollo sostenible cultivando los valores en los
                estudiantes.”
              </p>
            </div>
          </div>
        </div>

        {/*  MISIÓN */}
        <div className="row align-items-center flex-md-row-reverse mb-5" data-aos="fade-left">
          <div className="col-md-6 text-center">
            <img src={misionImg} alt="Misión" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaBullseye className="mv-icon" />
              <h2 className="section-title">Nuestra Misión</h2>
              <p>
                “Somos un Instituto que forma profesionales técnicos con valores, dominio
                de las tecnologías de la información y comunicación, y compromiso con el
                cuidado del medio ambiente. Éticos, morales, competitivos y acordes a las
                exigencias del mercado laboral, promoviendo la responsabilidad social y el
                uso de las TICs.”
              </p>
            </div>
          </div>
        </div>

        {/*  VALORES */}
        <div className="row align-items-center mb-5" data-aos="fade-right">
          <div className="col-md-6 text-center">
            <img src={valoresImg} alt="Valores" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaHandsHelping className="mv-icon" />
              <h2 className="section-title">Nuestros Valores</h2>
              <p>
                En el Instituto promovemos los valores que fortalecen nuestra identidad
                institucional y la formación integral de nuestros estudiantes:
              </p>
              <ul className="valores-list text-start mt-3">
                <li>🤝 <strong>Solidaridad</strong></li>
                <li>🏫 <strong>Identidad</strong></li>
                <li>👥 <strong>Trabajo en equipo</strong></li>
                <li>⏰ <strong>Puntualidad</strong></li>
                <li>🙏 <strong>Respeto</strong></li>
                <li>⚖️ <strong>Justicia</strong></li>
                <li>💎 <strong>Honestidad</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MisionVision;

